import FileSolid from '@eduzz/houston-icons/FileSolid';
import InfoSolidIcon from '@eduzz/houston-icons/InfoSolid';
import QuickSaleOutlineIcon from '@eduzz/houston-icons/QuickSaleOutline';
import Box from '@eduzz/houston-ui/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

import useStyles from './styles';

type DisableComponents = {
  tooltip: boolean;
  button: boolean;
};

type Props = {
  onSubmit: () => void;
  onSubmitDraft: () => void;
  disabledDraft: DisableComponents;
  disabled: DisableComponents;
  isService: boolean;
};

const DraftButtons = ({ onSubmit, onSubmitDraft, disabledDraft, disabled, isService }: Props) => {
  const classes = useStyles();

  const text = isService
    ? 'Clicando em pronto para vender seu serviço será enviado para moderação e o link de vendas ficará habilitado.'
    : 'Clicando em pronto para vender seu produto será enviado para moderação e o link de vendas ficará habilitado.';
  return (
    <Grid container justify='flex-end' className={classes.saveButtonDiv}>
      <Grid item xs={12} key='helper-text' className='helper-text'>
        <Grid container justify='flex-end'>
          <Box className={classes.infoReadyToSell}>
            <InfoSolidIcon size='sm' />
            {text}
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12} key='draft-buttons'>
        <Grid container justify='flex-end' spacing={2}>
          <Grid item>
            <Tooltip placement='top' title='Preencha o título para poder salvar como rascunho' disableHoverListener={disabledDraft.tooltip}>
              <div>
                <Button
                  id='new-product-draft-button'
                  variant='outlined'
                  color='primary'
                  onClick={() => onSubmitDraft()}
                  startIcon={<FileSolid />}
                  disabled={disabledDraft.button}
                >
                  Salvar como rascunho
                </Button>
              </div>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip placement='top' title='Preencha os campos obrigatórios para salvar' disableHoverListener={disabled.tooltip}>
              <div>
                <Button
                  id='new-product-save-button'
                  variant='contained'
                  color='primary'
                  onClick={() => onSubmit()}
                  startIcon={<QuickSaleOutlineIcon />}
                  disabled={disabled.button}
                >
                  Pronto para vender
                </Button>
              </div>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DraftButtons;
